function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 36,
  cy: 36,
  r: 36,
  fill: "#374151"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M48.2119 27.3481C50.0081 25.205 51 22.5162 51 19.7806V14H21V19.7806C21 22.5162 21.99 25.2031 23.7881 27.3463L29.5763 34.2463C30.6375 35.5156 30.645 37.2931 29.5931 38.57L23.7244 45.6838C21.9675 47.8138 21 50.4744 21 53.1744V59H51V53.1744C51 50.4744 50.0306 47.8156 48.2756 45.6856L42.4069 38.5719C41.3531 37.295 41.3606 35.5175 42.4237 34.2481L48.2119 27.3481ZM47.25 19.6231C47.25 21.6875 46.5694 23.4669 45.3375 24.9369L43.5038 27.125H28.4963L26.6625 24.9369C25.425 23.465 24.75 21.6819 24.75 19.6231H47.25V19.6231ZM45.3825 48.0706C46.605 49.5537 47.25 51.305 47.25 53.375H45.2606C41.625 49.625 36 49.625 36 49.625C36 49.625 30.375 49.625 26.7394 53.375H24.75C24.75 51.305 25.395 49.5519 26.6175 48.0706L32.4844 40.9588C33.1256 40.1806 33.555 39.2975 33.8175 38.3769H34.125V40.2519H37.875V38.3769H38.1806C38.445 39.2975 38.8725 40.1806 39.5137 40.9569L45.3825 48.0706ZM34.125 45.875H37.875V47.75H34.125V45.875ZM34.125 42.125H37.875V44H34.125V42.125Z",
  fill: "#9CA3AF"
});

function SvgUpcoming(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpcoming);
export default __webpack_public_path__ + "static/media/upcoming.a9ca296dfc81d4104c7fd20b3f5d0196.svg";
export { ForwardRef as ReactComponent };